import queryString from 'query-string';
import { demoUsersLogins } from '../../../../config';

export const getEmailFromLocationSearch = search => {
  return queryString.parse(search)['email'];
};

export const getProductFromLocationSearch = search => {
  return queryString.parse(search)['client_id'];
};

export const getDemoUserPassword = email => {
  return demoUsersLogins[email];
};
